import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a73e4df6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["element-loading-spinner"];
var _hoisted_2 = {
  class: "d-flex flex-column flex-lg-row modal-floor-item"
};
var _hoisted_3 = {
  class: "d-flex flex-column"
};
var _hoisted_4 = {
  class: "mb-5"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "upload-botton-warning"
  }, "Il préfère télécharger une image de dimension 1920×1080 px", -1);
});

var _hoisted_6 = {
  class: "w-100"
};
var _hoisted_7 = {
  class: "m-0 p-1 d-flex flex-lg-column flex-row justify-content-between nav-type-espace"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "mt-3 ms-2"
};
var _hoisted_10 = {
  class: "d-flex flex-column",
  style: {
    "flex": "60%"
  }
};
var _hoisted_11 = {
  class: "overflow-auto"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = ["src", "alt"];
var _hoisted_14 = {
  key: 1,
  class: "ps-0 espaces"
};
var _hoisted_15 = ["onClick"];
var _hoisted_16 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_UploadButton = _resolveComponent("UploadButton");

  var _component_ModalLayout = _resolveComponent("ModalLayout");

  var _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createBlock(_component_ModalLayout, {
    "close-button": false,
    "max-width": "1000px",
    title: "Choisir un espace"
  }, {
    default: _withCtx(function () {
      return [_withDirectives((_openBlock(), _createElementBlock("div", {
        "element-loading-text": "Chargement en cours...",
        "element-loading-spinner": _ctx.spinnerSvg,
        "element-loading-svg-view-box": "-10, -10, 50, 50",
        "element-loading-background": "rgba(0, 0, 0, 0.8)",
        class: "d-flex flex-column min-600px"
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_UploadButton, {
        uploadImage: _ctx.handleUploadImage,
        title: 'Télécharger une image',
        src: 'svg/icons/icon_upload.svg',
        alt: 'icon upload',
        description: "taille maximale de l'image: 10 MB"
      }, null, 8, ["uploadImage", "src"]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.espaceData, function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.id,
          onClick: function onClick($event) {
            return _ctx.chooseEspace(item.id, item.key);
          },
          style: {
            "cursor": "pointer"
          },
          class: _normalizeClass(["h-40px list-unstyled nav-modal-espace", [_ctx.idEspace === item.id && 'active-item']])
        }, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.espace), 1)], 10, _hoisted_8);
      }), 128))])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_ctx.idEspace === 1 ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        class: _normalizeClass(["ps-0 espaces", _ctx.previewImage.length === 0 && 'noUploaded-image'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewImage, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          style: {
            "cursor": "pointer"
          },
          class: "rounded m-2 list-unstyled espace-image",
          onClick: function onClick($event) {
            return _ctx.chooseExample(item.name, item.link);
          }
        }, [_createElementVNode("img", {
          id: "img",
          class: "rounded",
          src: item.link,
          alt: item.name
        }, null, 8, _hoisted_13)], 8, _hoisted_12);
      }), 128))], 2)) : _createCommentVNode("", true), _ctx.idEspace !== 1 ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.espacesExemple, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          style: {
            "cursor": "pointer"
          },
          class: "rounded m-2 list-unstyled espace-image",
          onClick: function onClick($event) {
            return _ctx.chooseExample(item);
          }
        }, [_createElementVNode("img", {
          id: "img",
          class: "rounded",
          src: _ctx.getImageUrl(item),
          alt: item
        }, null, 8, _hoisted_16)], 8, _hoisted_15);
      }), 128))])) : _createCommentVNode("", true)])])])])], 8, _hoisted_1)), [[_directive_loading, _ctx.loading]])];
    }),
    _: 1
  });
}